var _circle, _circle2, _circle3, _circle4, _circle5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgCicularPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 658,
    viewBox: "0 0 655 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.4
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 329.217,
    cy: 329.221,
    r: 255.516,
    transform: "rotate(-70.5806 329.217 329.221)",
    stroke: "url(#paint0_linear_507_9647)",
    strokeWidth: 0.376867
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.218,
    cy: 329.221,
    r: 300.404,
    transform: "rotate(-90.3099 329.218 329.221)",
    stroke: "url(#paint1_linear_507_9647)",
    strokeWidth: 0.443074
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.218,
    cy: 329.221,
    r: 210.458,
    transform: "rotate(-70.5806 329.218 329.221)",
    stroke: "url(#paint2_linear_507_9647)",
    strokeWidth: 0.376867
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.216,
    cy: 329.223,
    r: 165.122,
    transform: "rotate(-70.5806 329.216 329.223)",
    stroke: "url(#paint3_linear_507_9647)",
    strokeWidth: 0.376867
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.216,
    cy: 329.224,
    r: 120.342,
    transform: "rotate(-90.3099 329.216 329.224)",
    stroke: "url(#paint4_linear_507_9647)",
    strokeWidth: 0.376867
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_9647",
    x1: 329.218,
    y1: 73.5162,
    x2: 329.218,
    y2: 584.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43669B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#D7DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#C6CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8994F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_507_9647",
    x1: 329.218,
    y1: 28.5959,
    x2: 329.218,
    y2: 629.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43669B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#D7DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#C6CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8994F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_507_9647",
    x1: 329.218,
    y1: 118.574,
    x2: 329.218,
    y2: 539.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43669B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#D7DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#C6CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8994F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_507_9647",
    x1: 329.216,
    y1: 163.913,
    x2: 329.216,
    y2: 494.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43669B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#D7DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#C6CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8994F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_507_9647",
    x1: 329.216,
    y1: 208.693,
    x2: 329.216,
    y2: 449.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#6ECA4E",
    stopOpacity: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#2A5FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01E54"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCicularPieChart);
export default __webpack_public_path__ + "static/media/bgCicularPieChart.5164c1d57bd3faab2b4a5e6c1858066b.svg";
export { ForwardRef as ReactComponent };